import { apiClient } from './axios';

import type {
  ShiftConfirmationQuery,
  CallWithContact,
  PaginatedResponse,
} from '@repo/shared-types';

export const shiftConfirmationsApi = {
  getShiftConfirmations: async (
    query?: Partial<ShiftConfirmationQuery>,
  ): Promise<PaginatedResponse<CallWithContact>> => {
    const response = await apiClient.get<PaginatedResponse<CallWithContact>>(
      '/shift-confirmations',
      { params: query },
    );
    return response.data;
  },
};
